module.exports = __webpack_public_path__ + "img/card-bus.adce4fdb.svg";